import React, { useState, useEffect } from "react";
import { Table, Button } from "antd";
import { api } from 'lib';
import { columnsData, addColumnsData } from "./ColumnsData";
import { IgtLoader } from 'Atoms';
import { getOperationColumn, getAddOperationColumn, getColumnSearchProps, EditableFormRow,EditableCell } from "common";
import { CSVLink } from "react-csv";

export const CrudTable = ({ isLoading, modelList }) => {
  const [data, setData] = useState(null)
  const [editingId, setEditingId] = useState("")
  const [, setSearchText] = useState("")
  const [, setSearchedColumn] = useState("")

  useEffect(() => {
    setData(modelList)
  }, [isLoading, modelList])

  const isEditing = record => {
    return record.id === editingId;
  };

  const handleAdd = (form) => {
    form.validateFields((error, row) => {
      if (error) {
        return;
      }
      const body = {
        code: row["code"],
        country: row["country"],
        gl_type: row["gl_type"],
        aws_gl: row["aws_gl"],
        gcp_gl: row["gcp_gl"],
        azure_gl: row["azure_gl"]
      }
      addDatabaseRecord([...data], body, form)
    })
  }

  const handleDelete = (id) => {
    api.delete("/companies/" + id)
      .then(resp => {
        alert("The company has been deleted!");
        setData(data.filter((item) => item.id !== id))
      })
      .catch(err => {
        alert(err.response.data['error'])
        console.error("API Error: ", err)
      })
  }

  const edit = (id) => {
    setEditingId(id)
  }

  const addDatabaseRecord  = (newData, body, form) => {
    api.post("/companies", body)
      .then(resp => {
        console.log("Added a new company record!")
        console.log(resp.status)
        newData.unshift({ ...resp.data.data })  // Add will update the first element!

        setData(newData)
        setEditingId("")
        alert("Successfully added a new company!")
        form.resetFields()
      })
      .catch(err => {
        alert("There was a problem adding this company record. Please try again.")
        console.error("API Error: ", err)
      })
  }
  
  const editDatabaseRecord = (newData, id, body) => {
    const index = newData.findIndex(item => id === item.id);

    api.put("/companies/" + id, body)
      .then(resp => {
        console.log("Updated a company record!")
        console.log(resp.status)
        newData.splice(index, 1, {...resp.data.data});
        setData(newData)
        setEditingId("")
      })
      .catch(err => {
        alert("There was a problem updating this company record. Please try again.")
        console.error("API Error: ", err)
      })
  }

  const save = (form, id) => {
    form.validateFields((error, row) => {
      if (error) {
        return;
      }
      const newData = [...data];

      const body = {
          code: row["code"],
          country: row["country"],
          gl_type: row["gl_type"],
          aws_gl: row["aws_gl"],
          gcp_gl: row["gcp_gl"],
          azure_gl: row["azure_gl"]
        }

        editDatabaseRecord(newData, id, body)
    });
  }

  const cancel = () => {
      setEditingId("")
  };

  
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0])
    setSearchedColumn(dataIndex)
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText({ searchText: "" })
  };

  const defaultColumns = [
    ...columnsData.map(column => {
      return column.isSearchable ? {
        ...column,
        ...getColumnSearchProps(column.dataIndex, handleSearch, handleReset)
      } : column
    }),
    getOperationColumn(editingId, isEditing, save, cancel, edit, handleDelete, "5%", false)
  ].map(col => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      sorter:  (rowA, rowB) => col.sorter(rowA[col.dataIndex], rowB[col.dataIndex]),
      onCell: record => {
        const checkInput = index => {
          switch (index) {
            case "created_at":
              return "date";
            default:
              return "text";
          }
        };
        return {
          record,
          inputType: checkInput(col.dataIndex),
          dataIndex: col.dataIndex,
          title: col.title,
          editing: isEditing(record)
        };
      }
    };
  });

  const defaultAddColumns = [
    ...addColumnsData,
    getAddOperationColumn(handleAdd, "4%")
  ].map(col => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: record => {
        const checkInput = index => {
          switch (index) {
            case "created_at":
              return "date";
            default:
              return "text";
          }
        };
        return {
          record,
          inputType: checkInput(col.dataIndex),
          dataIndex: col.dataIndex,
          title: col.title,
          editing: true 
        };
      }
    };
  });

  const CSVDataToDownloadFormat = (data) => {
    return data.map(company => {
      return {
        company_code: company.code,
        location: company.country,
        gl_type: company.gl_type,
        aws_gl: company.aws_gl,
        gcp_gl: company.gcp_gl,
        azure_gl: company.azure_gl,
        created_at: company.created_at
      }
    })
  }

  return (
    <>
      {isLoading ? <IgtLoader isLoading={isLoading} /> : (<>
      <Button style={{ margin: '5px' }} >
            {modelList && (
              <CSVLink 
                data={CSVDataToDownloadFormat(data)} 
                filename={'company_' + new Date().toISOString() + '.csv'}
              >
                Download CSV
              </CSVLink>
            )}
          </Button>
        <Table
        title={() => 'Add a Row'} 
          pagination={false} 
          rowKey="id"
          size='middle'
          components={{
            body: {
              row: EditableFormRow,
              cell: EditableCell
            }
          }}
          bordered
          dataSource={[{
            code: "",
            country: "",
            gl_type: "",
            aws_gl: "",
            gcp_gl: "",
            azure_gl: ""
          }]
        }
          columns={defaultAddColumns}
          rowClassName="editable-row"
        />
        <Table
       pagination={{ position: 'both' }}  // pagination={false} 

         title={() => 'Company Table'}

          rowKey="id"
          components={{
            body: {
              row: EditableFormRow,
              cell: EditableCell
            }
          }}
          size='middle'
          bordered
          dataSource={data}
          columns={defaultColumns}
          rowClassName="editable-row"
        />
      </>
      )}
    </>
  );
}